module.exports = __webpack_public_path__ + "static/img/header.1402d08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/student/header.png
// module id = sHms
// module chunks = 1